function isProductCustomisable(productSlug: string) {
  return productSlug?.includes('custom')
}

export { isProductCustomisable }
